import { Button } from '@mui/material';
import { pdf } from '@react-pdf/renderer';
import html2canvas from 'html2canvas';
import { useSnackbar } from 'notistack';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';
import { useFetch } from 'use-http';
import { v4 as uuidv4 } from 'uuid';
import {
  DrawerMUI,
  DrawerNewInspection,
  HeaderPage,
  TourWrapper,
} from 'components';
import { ExportsPanel } from 'components/ExportsPanel/ExportsPanel';
/* import { overviewData } from 'components/ExportsPanel/pdf/OverviewPdf/constants'; -*/
import { OverviewPdf } from 'components/ExportsPanel/pdf/OverviewPdf/OverviewPdf';
import { Pie } from 'components/Graphics/Overview/Pie';
import { avatar } from 'components/TabCreateInspection/costants';
import { apiBridges, apiCollaborators } from 'constants/api';
import { STRUCTURES_PATHS } from 'constants/paths';
import {
  PermissionType,
  PermissionTypeSelectOptions,
} from 'constants/permissions';
import { SubscriptionStatus } from 'constants/subscription';
import { tour_03 } from 'constants/tour';
import { useSubscription } from 'hooks';

import {
  useAuthSelector,
  useGlobalSelector,
  useInspectionSelector,
} from 'stores';
import { accessHasExpired } from 'utils';
import { downloadBlob } from 'utils/export';
import { handleUpload } from 'utils/upload';
import { getBase64Image, removeUnsafeCharacters } from 'utils/utilities';
import { steps } from './StructureDetail.tourSteps';
import Summary from './Summary/Summary';

const CanShareMap = {
  // this object maps the possibile actions on the sharing popover
  [PermissionType.CanView]: false,
  [PermissionType.CanEdit]: true,
  [PermissionType.CanViewByInspectionReference]: false,
  [PermissionType.NoPermission]: false,
};

const StructureShareOptions = PermissionTypeSelectOptions;
/* .filter(
  el => el.value !== PermissionType.CanView
); */

// trigger

const StructureDetail = () => {
  const { get, response, error } = useFetch();
  const navigate = useNavigate();
  const params = useParams();
  const { showLoader, hideLoader } = useGlobalSelector();
  const { setInspectionDisabled } = useInspectionSelector();
  const { user } = useAuthSelector();
  const { enqueueSnackbar } = useSnackbar();
  const id = params.structureId;
  const { subscriptionStatus } = useSubscription();
  const { get: exportLambdaUrl } = useFetch(
    process.env.REACT_APP_EXPORT_LAMBDA_URL
  );
  // Issue #1035, punto F1 (review BE §3a) — istanza dedicata per la GET del
  // rosone L0,1,2: `error` del `useFetch()` condiviso sopra pilota
  // `navigate(STRUCTURES_PATHS.STRUCTURES_LIST)` (effect poco sotto) — un
  // fallimento di questa sola GET (già pensata per fallire in modo
  // silenzioso, col fallback allo screenshot a video) manderebbe altrimenti
  // l'utente fuori dalla pagina.
  const { get: getExportOverview } = useFetch();

  //State
  const [canShare, setCanShare] = useState(false);
  const [userPermissionOnStructure, setUserPermissionOnStructure] = useState();
  const [structure, setStructure] = useState({});
  const [collaborators, setCollaborators] = useState([]);
  const [open, setOpen] = useState(false);
  const [openExportsPanel, setOpenExportsPanel] = useState(false);
  const [isStructureOwner, setIsStructureOwner] = useState(false);
  const [accessExpirationDate, setAccessExpirationDate] = useState(null);

  //   const [files, setFiles] = useState([]);

  const arbitraryIntCode = removeUnsafeCharacters(
    structure?.arbitraryInternalCode
  );
  const date = new Date();
  const currentDate = date.toLocaleDateString().replaceAll('/', '-');
  const currentTime = date.toLocaleTimeString('it-IT').replaceAll(':', '-');
  const pdfName = `${arbitraryIntCode} - Sintesi CdA Complessiva - ${currentDate} ${currentTime}`;

  const graphRef = useRef(null);
  const graphRef2 = useRef(null);
  const graph1CacheRef = useRef(null);
  const graph2CacheRef = useRef(null);
  // Issue #1035, punto F1 — il rosone per le Relazioni tecniche (tutte
  // L0,1,2, mai L3) non deve riflettere l'ultima attività di qualunque
  // tipologia (quella mostrata a video, graphRef sopra), ma specificamente
  // l'ultima attività L0,1,2 (requestUserLastValidL012InspectionId, già
  // nel dettaglio ponte — vedi apps/api/docs/
  // navigazione-ultima-attivita-per-livello.md). Renderizzato fuori
  // schermo con dati dedicati invece di riusare graphRef: GET
  // bridges/:id/overview accetta già ?inspectionId=, stesso pattern già
  // usato da TabOverview.jsx. chartID univoco ad ogni generazione: il
  // componente Pie ridisegna solo quando chartID cambia (useLayoutEffect
  // con deps [chartID]), un id fisso riusato tra due export mostrerebbe
  // dati vecchi.
  const exportGraphRef = useRef(null);
  const [exportCdaPie, setExportCdaPie] = useState(null);
  const [exportChartId, setExportChartId] = useState(null);

  const handleGraphsCaptured = (canvas1, canvas2) => {
    graph1CacheRef.current = canvas1;
    graph2CacheRef.current = canvas2;
  };

  const dataURItoBlob = dataURI => {
    var binary = atob(dataURI.split(',')[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: 'image/jpeg' });
  };

  const uploadTempCdAPie = async () => {
    try {
      showLoader();

      // Issue #1035, punto F1 — rosone scoped all'ultima attività L0,1,2
      // (vedi commento su exportGraphRef sopra), con fallback al vecchio
      // comportamento (screenshot del grafico a video) se manca l'id o la
      // GET fallisce, per non rompere l'export in quel caso limite.
      const l012InspectionId = structure?.requestUserLastValidL012InspectionId;
      let useExportPie = false;
      if (l012InspectionId) {
        const overviewL012 = await getExportOverview(
          `${apiBridges.ROOT}/${id}/overview?inspectionId=${l012InspectionId}`
        );
        if (overviewL012?.cdaPie) {
          setExportCdaPie(overviewL012.cdaPie);
          setExportChartId(`pie-export-${Date.now()}`);
          useExportPie = true;
        }
      }

      // Applica zoom 140%
      document.body.style.transformOrigin = 'top left';
      document.body.style.transform = 'scale(1)';
      document.body.style.width = `${100 / 1.5}%`;
      document.body.style.height = `${100 / 1.5}%`;

      // Attendi layout (+ mount/disegno del rosone fuori schermo, se usato).
      // Issue #1035, punto F1 (review BE §2) — 1500, non 200: Pie usa
      // am5themes_Animated, ~1s di animazione di comparsa. Col vecchio
      // flusso (screenshot del grafico già a video da tempo) 200ms
      // bastavano; il rosone fuori schermo invece monta e si disegna
      // adesso, 200ms lo catturerebbero vuoto o a metà.
      await new Promise(r => setTimeout(r, 1500));

      const canvas = await html2canvas(
        (useExportPie ? exportGraphRef : graphRef)?.current,
        {
          backgroundColor: null,
          scrollX: 0,
          scrollY: 0,
          scale: 4,
          //scale: window.devicePixelRatio || 2,
          // height: 280,

          // windowWidth: window.innerWidth,
          ignoreElements: element => element.classList.contains('swiper'),
        }
      );

      // Ripristina zoom pagina
      document.body.style.transform = '';
      document.body.style.width = '';
      document.body.style.height = '';

      if (useExportPie) {
        setExportChartId(null);
        setExportCdaPie(null);
      }

      const image = canvas.toDataURL('image/png', 2.0);
      const blobData = dataURItoBlob(image);

      // gestione caricamento screenshot su s3
      const idFile = `${uuidv4()}-${new Date().getTime()}`;
      if (blobData) {
        const res = await handleUpload(
          `bridges/${id}/temp-relazione-tecnica-cda-complessiva`,
          blobData,
          idFile,
          `${id}-${new Date().getTime()}-CdAGraph.png`
        );
        return res?.s3Path;
      }
    } catch (error) {
      console.log(error);
    } finally {
      hideLoader();
    }
  };

  // const uploadTempCdAPie = async () => {
  //   try {
  //     showLoader();

  //     const graphElement = document.getElementById('pie-two');
  //     if (!graphElement) {
  //       console.error('Grafico non trovato con id "pie-two"');
  //       return;
  //     }

  //     // Rimuovi eventuali zoom trasformazioni
  //     const originalTransform = graphElement.style.transform;
  //     const originalTransformOrigin = graphElement.style.transformOrigin;
  //     graphElement.style.transform = 'none';
  //     graphElement.style.transformOrigin = 'top left';

  //     // Aspetta il layout stabile
  //     await new Promise(r => setTimeout(r, 200));

  //     const canvas = await html2canvas(graphElement, {
  //       backgroundColor: null,
  //       scale: 4, // qui aumentiamo solo la risoluzione
  //       scrollX: 0,
  //       scrollY: 0,
  //       ignoreElements: element => element.classList.contains('swiper'),
  //     });

  //     // Ripristina trasformazioni originali
  //     graphElement.style.transform = originalTransform;
  //     graphElement.style.transformOrigin = originalTransformOrigin;

  //     const image = canvas.toDataURL('image/png', 2.0);
  //     const blobData = dataURItoBlob(image);
  //     const idFile = `${uuidv4()}-${new Date().getTime()}`;

  //     if (blobData) {
  //       const res = await handleUpload(
  //         `bridges/${id}/temp-relazione-tecnica-cda-complessiva`,
  //         blobData,
  //         idFile,
  //         `${id}-${new Date().getTime()}-CdAGraph.png`
  //       );
  //       return res?.s3Path;
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     hideLoader();
  //   }
  // };

  // GESTIONE IMMAGINI GRAFICI
  // const [graph1, setgraph1] = useState('');
  // const [graph2, setgraph2] = useState('');

  // useEffect(() => {
  //   getGraphImage();
  // }, []);

  // const getGraphImage = async () => {
  //   const canvas = await html2canvas(graphRef?.current, {
  //     backgroundColor: null,
  //     scrollX: 0,
  //     scrollY: 0,
  //     /* dpi: 5000, */
  //     scale: 2,
  //     height: 280,
  //     windowWidth: window.innerWidth,
  //     ignoreElements: element => element.classList.contains('swiper'),
  //   });
  //  // setgraph1(canvas);

  //   const canvas2 = await html2canvas(graphRef2?.current, {
  //     backgroundColor: null,
  //     scrollX: 0,
  //     scrollY: 0,
  //     windowWidth: 2300,
  //     height: 200,
  //     ignoreElements: element => element.classList.contains('swiper'),
  //   });
  //   //setgraph2(canvas2);
  // };

  const exportOverview = async formData => {
    try {
      showLoader();
      //const overviewData = await get(`exports/${id}/levelTwo`);
      const overviewData = await exportLambdaUrl(`/?bridgeId=${id}&type=27`);

      const canvas =
        graph1CacheRef.current ??
        (await html2canvas(graphRef?.current, {
          backgroundColor: null,
          scrollX: 0,
          scrollY: 0,
          scale: 2,
          height: 280,
          windowWidth: window.innerWidth,
          ignoreElements: element => element.classList.contains('swiper'),
        }));

      const canvas2 =
        graph2CacheRef.current ??
        (await html2canvas(graphRef2?.current, {
          backgroundColor: null,
          scrollX: 0,
          scrollY: 0,
          windowWidth: 2300,
          height: 200,
          ignoreElements: element => element.classList.contains('swiper'),
        }));
      // const image = graph1.toDataURL('image/png', 1.0);
      // const image2 = graph2.toDataURL('image/png', 1.0);
      const image = canvas.toDataURL('image/png', 1.0);
      const image2 = canvas2.toDataURL('image/png', 1.0);
      // const fotoBase64 = await getBase64Image(overviewData.fotoCopertina);
      const fotoBase64 = overviewData.fotoCopertina;

      console.log(fotoBase64, 'fotoBase64');
      const _overviewData = {
        ...overviewData,
        fotoCopertina: fotoBase64,
      };
      const PDFOverview = await pdf(
        <OverviewPdf
          imageData={image}
          imageData2={image2}
          pdfData={_overviewData}
          structure={structure}
          formData={formData}
        />
      ).toBlob();
      downloadBlob(PDFOverview, pdfName);
      return PDFOverview;
    } catch (error) {
      console.log(error);
      return enqueueSnackbar(`Impossibile eseguire l'esportazione`, {
        variant: 'error',
      });
    } finally {
      hideLoader();
    }
  };

  const shareStructure = () => {
    handleCollaborators();
  };

  const handleCollaborators = async () => {
    const res = await get(`${apiCollaborators.ROOT}/structures/${id}`);
    setCollaborators(
      res
        .map(el => {
          return {
            ...el,
            collaborationInfo: {
              ...el?.sharedStructuresBy[0],
              type: el?.collaboratorOf[0]?.type,
            },
          };
        })
        .filter(
          el =>
            el?.collaborationInfo?.permission !==
            PermissionType.CanViewByInspectionReference
        )
    );
  };

  const handleMyPermissions = async () => {
    const res = await get(
      `${apiBridges.ROOT}/${id}${apiBridges.MY_PERMISSIONS}`
    );
    if (!res) {
      setCanShare(false);
    } else {
      setCanShare(CanShareMap[res?.permission]);
      setUserPermissionOnStructure(res?.permission);
      if (res.accessExpiration) {
        setAccessExpirationDate(res.accessExpiration);
        if (accessHasExpired(res.accessExpiration)) {
          navigate(STRUCTURES_PATHS.STRUCTURES_LIST);
        }
      }
    }
  };

  useEffect(() => {
    if (id) {
      handleCollaborators();
      handleMyPermissions();
    }
  }, [id]);

  useEffect(() => {
    if (!open) {
      handleCollaborators();
      handleMyPermissions();
    }
  }, [open]);

  useEffect(() => {
    error && navigate(STRUCTURES_PATHS.STRUCTURES_LIST);
  }, [error]);

  //useEffect()
  //   const [files, setFiles] = useState([]);
  const handleDetail = async () => {
    let result = '';
    let involvedLevelsColors = '';
    try {
      showLoader();
      result = await get(`${apiBridges.ROOT}/${id}`);
      involvedLevelsColors = await get(
        `${apiBridges.ROOT}/${id}/involvedLevelsColors`
      );
      if (result && involvedLevelsColors) {
        result['involvedLevelsColors'] = involvedLevelsColors;
      }
      // e-2026-06-t21 — GET :id (getDetail/getOverviewBridgeDetail) non calcola
      // requestUserLastValidL012InspectionId/L3InspectionId: solo GET
      // :id/overview (getOverviewDetail) lo fa (vedi apps/api/docs/
      // navigazione-ultima-attivita-per-livello.md). `structure` è la fonte
      // condivisa da tutte le tab (TabL0/TabL1/TabL3/TabOverview) per i
      // bottoni "Approfondisci", quindi i due id vanno fusi qui invece che
      // ri-richiesti in ciascuna tab.
      if (result) {
        const overviewDetail = await get(`${apiBridges.ROOT}/${id}/overview`);
        if (overviewDetail) {
          result['requestUserLastValidL012InspectionId'] =
            overviewDetail.requestUserLastValidL012InspectionId;
          result['requestUserLastValidL3InspectionId'] =
            overviewDetail.requestUserLastValidL3InspectionId;
        }
      }
    } catch (err) {
      console.error('Error in put diagnosis: ', err);
    } finally {
      hideLoader();
      response.ok && setStructure(result);
    }
  };
  useEffect(() => {
    id && handleDetail().catch(console.error);
  }, [id]);
  useEffect(() => {
    if (!open) {
      handleDetail().catch(console.error);
    }
  }, [open]);

  useEffect(() => {
    if (user && structure) {
      if (
        user.id === structure?.owner?.id ||
        user.parent?.id === structure?.owner?.id
      ) {
        setIsStructureOwner(true);
      }
    }
  }, [user, structure]);

  useEffect(() => {
    setInspectionDisabled(null);
  }, []);

  const structureName = structure?.name || '-';
  // Issue #1021, riapertura 2026-09-04, punto 4 — la schermata del ponte deve
  // mostrare SOLO il nome: il suffisso "- Schede X" resta solo nel titolo
  // dell'attività (useInspection.js), non qui.
  const titlePage = structureName;
  const council = structure?.council?.name;
  const address =
    structure?.address || structure?.province?.code || council
      ? `${structure?.address ? structure.address + ',' : ''} ${council} (${
          structure?.province?.code
        })`
      : '-';
  const internalCode = structure?.internalCode || '-';
  const owner = structure?.owner?.email || '-';
  const infoData = {
    street: address || '-',
    city: structure?.council?.name
      ? `Comune di ${structure?.council?.name}`
      : '-',
    code: internalCode ? `ID ${internalCode}` : '-',
    owner,
  };
  const lastInspectionId = structure?.lastInspectionId;
  // Un'attività L3 non ha una formula di completamento (il FE fa solo
  // echo-back di completionPercentage, mai ricalcolato), quindi
  // exportInspectionCompletionPercentage resta a 0 per tutta la durata di
  // un'attività L3 anche a compilazione avanzata — non va trattato come
  // "niente da esportare" in quel caso. involvedLevelsColors[3] === 'draft'
  // (indice L3) implica che l'attività L3 è quella corrente: sullo stesso
  // ponte può esserci una sola attività OnGoing alla volta, quindi se l'L3 è
  // in bozza è necessariamente quella puntata da lastInspectionId.
  const lastInspectionIsOngoingL3Activity =
    structure?.involvedLevelsColors?.[3] === 'draft';

  //console.log(id, 'id');

  return (
    <>
      {structure && (
        <HeaderPage
          back={STRUCTURES_PATHS.STRUCTURES_LIST}
          shareOptions={StructureShareOptions}
          sharedWith={collaborators}
          canShare={canShare}
          isOwner={isStructureOwner}
          handleShare={shareStructure}
          shareRoute={apiCollaborators.STRUCTURE_COLLBAORATORS}
          entityId={id}
          accessExpiration={accessExpirationDate}
          buttons={
            <div className={tour_03.step_03}>
              <Button
                disabled={
                  !lastInspectionId ||
                  (structure.exportInspectionCompletionPercentage === 0 &&
                    !lastInspectionIsOngoingL3Activity)
                }
                variant="outlined"
                color="secondary"
                size="small"
                onClick={() => setOpenExportsPanel(!openExportsPanel)}
              >
                Esporta
              </Button>

              {userPermissionOnStructure === PermissionType.CanEdit &&
                subscriptionStatus === SubscriptionStatus.ATTIVA && (
                  <Button
                    onClick={() =>
                      navigate(
                        STRUCTURES_PATHS.DUPLICATE_STRUCTURE.replace(
                          ':structureId',
                          id
                        )
                      )
                    }
                    variant="outlined"
                    color="secondary"
                    size="small"
                  >
                    Duplica opera
                  </Button>
                )}

              {lastInspectionId && (
                <Button
                  disabled={!lastInspectionId}
                  variant="containedBlack"
                  color="secondary"
                  size="small"
                  // onClick={() =>
                  //   navigate(`/structures/list/${id}/inspection/archive`)
                  // }
                  onClick={() =>
                    navigate(
                      STRUCTURES_PATHS.INSPECTIONS_ARCHIVE.replace(
                        ':structureId',
                        structure.id
                      )
                    )
                  }
                >
                  Archivio attività
                </Button>
              )}
              {userPermissionOnStructure === PermissionType.CanEdit && (
                <Button
                  onClick={() => setOpen(!open)}
                  variant="contained"
                  color="primary"
                  size="small"
                  /* disabled={id === '11' || id === '22'} */
                >
                  Nuova attività
                </Button>
              )}
            </div>
          }
          title={titlePage}
          avatar={avatar}
          infoData={infoData}
        />
      )}

      <DrawerNewInspection
        open={open}
        setOpen={setOpen}
        isOwner={isStructureOwner}
        l3Access={structure?.l3Access}
      />
      <DrawerMUI
        onClose={() => !structure.firstExportDate && window.location.reload()}
        open={openExportsPanel}
        setOpen={setOpenExportsPanel}
        title={'Esporta'}
        subtitle={`Seleziona la tipologia di esportazione desiderata.`}
        // subtitle={`Seleziona la tipologia di esportazione desiderata, una volta esportati troverai i file all'interno dell'area Documenti della piattaforma.`}
      >
        <ExportsPanel
          exportOverview={exportOverview}
          uploadTempCdAPie={uploadTempCdAPie}
          setOpen={setOpenExportsPanel}
          open={openExportsPanel}
          structureName={structure?.name}
          structureInfo={structure}
          pdfName={pdfName}
        />
      </DrawerMUI>
      {structure?.id && (
        <Summary
          structure={structure}
          userPermissionOnStructure={userPermissionOnStructure}
          graphRef={graphRef}
          graphRef2={graphRef2}
          onGraphsCaptured={handleGraphsCaptured}
          openDrawerNewInspection={open}
          setOpenDrawerNewInspection={setOpen}
        />
      )}
      <TourWrapper steps={steps} />
      {/* Issue #1035, punto F1 — rosone L0,1,2 per le Relazioni tecniche,
      vedi commento su exportGraphRef più sopra: opacity 0 (non
      display:none, html2canvas non catturerebbe l'elemento) e fuori dal
      flusso visibile, ma montato nel DOM normale perché il grafico amCharts
      ha bisogno di dimensioni reali per disegnarsi. */}
      {exportChartId && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '300px',
            height: '300px',
            opacity: 0,
            pointerEvents: 'none',
            zIndex: -1,
          }}
        >
          <div ref={exportGraphRef} style={{ width: '100%', height: '100%' }}>
            <Pie chartID={exportChartId} cda={exportCdaPie} />
          </div>
        </div>
      )}
    </>
  );
};

export default StructureDetail;
